// ============================================================================
// BonBoZ: chủ đề mẫu trả lời — bộ nạp dùng chung.
//
// Ba chỗ cần cùng một danh sách: bảng chọn mẫu ở khung soạn tin, danh sách mẫu
// trong Cài đặt, và màn quản lý chủ đề. Đệm theo promise giống `pageConfig.js`
// nên mở bảng chọn mẫu mười lần vẫn chỉ một request.
//
// `dsChuDe` là ref để giao diện tự vẽ lại sau khi thêm/sửa/xoá chủ đề.
// ============================================================================
import { ref } from 'vue';
import ChuDeMauAPI from 'dashboard/api/bonboz/chuDeMau';

/** [{ id, ten, mau, so_mau }] */
export const dsChuDe = ref([]);

let dangNap = null;

/** `force`: nạp lại thật, dùng sau khi sửa danh sách chủ đề. */
export const napChuDe = (force = false) => {
  if (dangNap && !force) return dangNap;
  dangNap = ChuDeMauAPI.get()
    .then(({ data }) => {
      dsChuDe.value = data || [];
      return dsChuDe.value;
    })
    .catch(() => dsChuDe.value); // hỏng thì mẫu hiện không màu, không chặn việc trực
  return dangNap;
};

export const chuDeTheoId = id =>
  id ? dsChuDe.value.find(c => Number(c.id) === Number(id)) : undefined;

/**
 * Màu chip sinh từ MỘT mã hex: chữ là chính mã đó, nền là mã đó pha loãng.
 * Nhờ vậy không phải lưu cặp màu cho nền sáng và nền tối — cùng một công thức
 * đọc được ở cả hai, và người chọn màu chỉ phải chọn một lần.
 */
export const mauChip = mau => ({
  color: mau,
  backgroundColor: `${mau}24`,
});

// 8 màu chọn sẵn, đã thử trên cả nền sáng lẫn nền tối của dashboard. Ai muốn
// màu khác vẫn có ô chọn màu tự do ngay cạnh.
export const MAU_SAN = [
  '#d4587a',
  '#d1873c',
  '#c0a038',
  '#2f9c6b',
  '#4685c8',
  '#7f63c4',
  '#9a7a58',
  '#75847d',
];
